import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

export interface Breadcrumb {
  id?: string;
  name: string;
}

@UntilDestroy()
@Component({
  selector: 'sd-clarity-file-browser-breadcrumb',
  imports: [CommonModule],
  templateUrl: './clarity-file-browser-breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClarityFileBrowserBreadcrumbComponent {
  readonly breadcrumbs = input<Breadcrumb[]>([]);
  readonly disabled = input(false);

  readonly onBreadcrumbClick = output<Breadcrumb>();

  breadcrumbClick(breadcrumb: Breadcrumb) {
    if (this.disabled()) return;

    this.onBreadcrumbClick.emit(breadcrumb);
  }
}
